interface Props {
  onAccept: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export default function ChatConsent({ onAccept, onCancel, isLoading }: Props) {
  return (
    <div className="flex flex-col gap-[var(--chat-space-08,48px)] items-start py-[var(--chat-space-05)] w-[313px]">
      <p className="font-['Inter'] font-normal text-[16px] leading-[1.5] text-[var(--chat-black)]">
        This chat is powered by AI and may provide general health information,
        but it does not provide medical advice. This chat will not be monitored
        by a healthcare professional and should not be used in the event of a
        medical emergency. Always consult with a healthcare provider for any
        specific questions around diagnosis and treatment. By continuing, you
        agree to our{" "}
        <a
          href="https://www.evvy.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          className="text-inherit underline persistSize"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          href="https://www.evvy.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-inherit underline persistSize"
        >
          Privacy Policy
        </a>
        .
      </p>

      <div className="flex gap-[var(--chat-space-03)] items-start pr-[var(--chat-space-07)] w-[313px]">
        <button
          onClick={onAccept}
          disabled={isLoading}
          className="unset flex-1 h-[40px] flex items-center justify-center bg-[var(--chat-black)] border border-[var(--chat-black)] rounded-[var(--chat-corner-base)] text-white font-['Inter'] font-semibold text-[14px] sm:text-[16px] leading-none normal-case tracking-normal disabled:opacity-50"
        >
          Accept
        </button>
        <button
          onClick={onCancel}
          disabled={isLoading}
          className="unset flex-1 h-[40px] flex items-center justify-center bg-transparent border border-[var(--chat-grey-100)] rounded-[var(--chat-corner-base)] text-[var(--chat-black)] font-['Inter'] font-semibold text-[14px] sm:text-[16px] leading-none normal-case tracking-normal"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
